<script>
import ItemComponent from './Item/component.vue';

export default {
  components: {
    ItemComponent,
  },
  props: {
    module: {
      type: Object,
    },
    isDefaultTariff: {
      type: Boolean,
    }
  },
  methods: {
    add() {
      this.module.add();
    },
    remove(item) {
      this.module.remove(item);
    },
  },
};
</script>
<template>
  <Card>
    <CardTitle>
      Даты тура
      <BtnPrimary
        slot="btn"
        @click="add"
      >
        Добавить дату
      </BtnPrimary>
    </CardTitle>
    <ItemComponent
      v-for="(item, idx) in module.items"
      :key="idx"
      :module="item"
      @remove="remove(item)"
    />
    <CardNoLength v-if="!module.items.length">
      Добавьте даты тура
    </CardNoLength>
  </Card>
</template>
<style lang="scss">

</style>
